const REACT_APP_TAGGUN_API_KEY = "b8034360bdb311ec8215c512ccf27e54";

export default REACT_APP_TAGGUN_API_KEY;
